import React, { useState } from 'react';

const ManageAdmins = () => {
    const [admins, setAdmins] = useState([{ id: 1, name: 'Admin1' }]);

    const handleDelete = (id: number) => {
        setAdmins(admins.filter((admin) => admin.id !== id));
    };

    return (
        <div>
            <h2>Manage Admins</h2>
            <ul>
                {admins.map((admin) => (
                    <li key={admin.id}>
                        {admin.name}
                        <button onClick={() => handleDelete(admin.id)}>Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ManageAdmins;
